function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 12.5,
  r: 3.5,
  stroke: "#DE3E5B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.02002 12C5.14359 15.1381 6.30414 18.1466 8.32002 20.5547C9.34185 21.6649 10.5993 22.5324 12 23.0933V31",
  stroke: "#DE3E5B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1052 8.21069C23.3739 8.57697 22.9393 9.35165 23.0079 10.1667C23.0079 10.2147 23.3319 15.0254 20.7412 17.8454C20.3029 18.3071 19.7944 18.6968 19.2345 19H12.7665C12.2146 18.7008 11.7118 18.3185 11.2759 17.8667C8.66653 15.0374 8.98653 10.252 8.99453 10.16C9.05983 9.3467 8.62451 8.57525 7.89453 8.21069",
  stroke: "#DE3E5B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20 31V23.0933C21.4002 22.5339 22.6576 21.6683 23.68 20.56C25.697 18.1505 26.8576 15.1399 26.98 12",
  stroke: "#DE3E5B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0012 5.0066C19.7292 3.66528 12.2732 3.66528 5.00122 5.0066",
  stroke: "#DE3E5B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31 7C31 8.10457 30.1046 9 29 9C27.8954 9 27 8.10457 27 7V3C27 1.89543 27.8954 1 29 1C30.1046 1 31 1.89543 31 3V7Z",
  stroke: "#DE3E5B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 7C5 8.10457 4.10457 9 3 9C1.89543 9 1 8.10457 1 7V3C1 1.89543 1.89543 1 3 1C4.10457 1 5 1.89543 5 3V7Z",
  stroke: "#DE3E5B",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgWorkout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkout);
export default __webpack_public_path__ + "static/media/workout.6023b3ba78ee59401c388a79d2303144.svg";
export { ForwardRef as ReactComponent };